import { ThemeProvider } from "@emotion/react";
import { Avatar, Chip } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { createTheme, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";

const colortheme = createTheme({
    palette: {
        primary: {
            main: "#292739",
        },
    },
    typography: {
        fontFamily: ["lato"].join(","),
    },
});


const ParaText = styled(Typography)(({ theme }) => ({
    fontSize: "1rem",
    color: "#ffffff",
}));

const TitleText = styled(Typography)(({ theme }) => ({
    fontSize: "2.4rem",
    fontWeight: "bold",
    color: "#ffffff",
}));

const RewardCard = styled(Box)(({ theme }) => ({
    background: "linear-gradient(100deg, #325e6a, #313646)",
    padding: "3rem",
    borderRadius: "30px",
    marginBottom: "1rem",
    boxShadow: colortheme.shadows[4],
    // #325e6a
    // #313646
    //shadow rgba(0,0,0,0.10196078431372549 )
}));

const SmallRewardCard = styled(RewardCard)(({ theme }) => ({
    background: "linear-gradient(100deg, #325e6a, #313646)",
    padding: "1.5rem",
    borderRadius: "30px",
    marginBottom: "1rem",
    boxShadow: colortheme.shadows[4],
    overflow: "hidden",
    position: "relative",
    // #325e6a
    // #313646
    //shadow rgba(0,0,0,0.10196078431372549 )
}));

const LightChip = styled(Chip)(({ theme }) => ({
    backgroundColor: "rgba(0,0,0,.1)",
    color: "#fff",
    fontSize: ".9rem",
    padding: "1.5rem .8rem",
    borderRadius: "25px",
    height: "2rem",
    '& .MuiAvatar-root img': {
        width: "25px",
        height: "25px",
    },
}));

const RewardCardLayer = styled(Box)(({ theme }) => ({
    backgroundColor: "#C2CEED",
    borderRadius: "100% 75% 30px 30px",
    boxShadow: colortheme.shadows[4],
    position: "absolute",
    top: "50%",
    left: '50%',
    width: "120%",
    height: "50%",
    opacity: "0.05",
    zIndex: "0",
    transform: "translate(-50%)",
    /* overflow: hidden; */
}));

const RewardCardSmallLayer = styled(RewardCardLayer)(({ theme }) => ({
    borderRadius: "250% 50% 30px 30px",
    left: '50%',
    width: "150%",
    height: "250%",
}));
 
const CreatorFundBody = () => {
    const useravatar = require("assets/Profile/buku_default_avatar.png");
    return (
        <React.Fragment>
            <ThemeProvider theme={colortheme}>
                <Box>
                    <TitleText style={{ fontSize: "1.4rem", margin: "1.8rem 0rem" }}>
                        Recent winners
                    </TitleText>

                    <SmallRewardCard>
                        <RewardCardSmallLayer></RewardCardSmallLayer>
                        <Grid
                            container
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={6}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ParaText>
                                    02/27
                                    <LightChip
                                        avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                                        label="@leahx1621"
                                        style={{ marginLeft: "25px", }}
                                    />
                                </ParaText>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: "end" }}>
                                <ParaText
                                    style={{
                                        fontSize: "1.4rem",
                                        marginRight: "1rem",
                                    }}
                                >
                                    0.03 ETH
                                    <span style={{color: "#c1c1c1", marginLeft: "1.2rem",}}>$160</span>
                                </ParaText>
                            </Grid>
                        </Grid>

                    </SmallRewardCard>

                    <SmallRewardCard>
                        <RewardCardSmallLayer></RewardCardSmallLayer>
                        <Grid
                            container
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={6}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ParaText>
                                    02/27
                                    <LightChip
                                        avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                                        label="@leahx1621"
                                        style={{ marginLeft: "25px", }}
                                    />
                                </ParaText>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: "end" }}>
                                <ParaText
                                    style={{
                                        fontSize: "1.4rem",
                                        marginRight: "1rem",
                                    }}
                                >
                                    0.03 ETH
                                    <span style={{color: "#c1c1c1", marginLeft: "1.2rem",}}>$160</span>
                                </ParaText>
                            </Grid>
                        </Grid>

                    </SmallRewardCard>

                    <SmallRewardCard>
                        <RewardCardSmallLayer></RewardCardSmallLayer>
                        <Grid
                            container
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={6}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ParaText>
                                    02/27
                                    <LightChip
                                        avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                                        label="@leahx1621"
                                        style={{ marginLeft: "25px", }}
                                    />
                                </ParaText>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: "end" }}>
                                <ParaText
                                    style={{
                                        fontSize: "1.4rem",
                                        marginRight: "1rem",
                                    }}
                                >
                                    0.03 ETH
                                    <span style={{color: "#c1c1c1", marginLeft: "1.2rem",}}>$160</span>
                                </ParaText>
                            </Grid>
                        </Grid>

                    </SmallRewardCard>

                    <SmallRewardCard>
                        <RewardCardSmallLayer></RewardCardSmallLayer>
                        <Grid
                            container
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={6}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ParaText>
                                    02/27
                                    <LightChip
                                        avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                                        label="@leahx1621"
                                        style={{ marginLeft: "25px", }}
                                    />
                                </ParaText>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: "end" }}>
                                <ParaText
                                    style={{
                                        fontSize: "1.4rem",
                                        marginRight: "1rem",
                                    }}
                                >
                                    0.03 ETH
                                    <span style={{color: "#c1c1c1", marginLeft: "1.2rem",}}>$160</span>
                                </ParaText>
                            </Grid>
                        </Grid>

                    </SmallRewardCard>

                    <SmallRewardCard>
                        <RewardCardSmallLayer></RewardCardSmallLayer>
                        <Grid
                            container
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={6}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ParaText>
                                    02/27
                                    <LightChip
                                        avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                                        label="@leahx1621"
                                        style={{ marginLeft: "25px", }}
                                    />
                                </ParaText>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: "end" }}>
                                <ParaText
                                    style={{
                                        fontSize: "1.4rem",
                                        marginRight: "1rem",
                                    }}
                                >
                                    0.03 ETH
                                    <span style={{color: "#c1c1c1", marginLeft: "1.2rem",}}>$160</span>
                                </ParaText>
                            </Grid>
                        </Grid>

                    </SmallRewardCard>

                    <SmallRewardCard>
                        <RewardCardSmallLayer></RewardCardSmallLayer>
                        <Grid
                            container
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={6}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ParaText>
                                    02/27
                                    <LightChip
                                        avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                                        label="@leahx1621"
                                        style={{ marginLeft: "25px", }}
                                    />
                                </ParaText>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: "end" }}>
                                <ParaText
                                    style={{
                                        fontSize: "1.4rem",
                                        marginRight: "1rem",
                                    }}
                                >
                                    0.03 ETH
                                    <span style={{color: "#c1c1c1", marginLeft: "1.2rem",}}>$160</span>
                                </ParaText>
                            </Grid>
                        </Grid>

                    </SmallRewardCard>

                    <SmallRewardCard>
                        <RewardCardSmallLayer></RewardCardSmallLayer>
                        <Grid
                            container
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={6}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ParaText>
                                    02/27
                                    <LightChip
                                        avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                                        label="@leahx1621"
                                        style={{ marginLeft: "25px", }}
                                    />
                                </ParaText>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: "end" }}>
                                <ParaText
                                    style={{
                                        fontSize: "1.4rem",
                                        marginRight: "1rem",
                                    }}
                                >
                                    0.03 ETH
                                    <span style={{color: "#c1c1c1", marginLeft: "1.2rem",}}>$160</span>
                                </ParaText>
                            </Grid>
                        </Grid>

                    </SmallRewardCard>

                    <SmallRewardCard>
                        <RewardCardSmallLayer></RewardCardSmallLayer>
                        <Grid
                            container
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={6}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ParaText>
                                    02/27
                                    <LightChip
                                        avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                                        label="@leahx1621"
                                        style={{ marginLeft: "25px", }}
                                    />
                                </ParaText>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: "end" }}>
                                <ParaText
                                    style={{
                                        fontSize: "1.4rem",
                                        marginRight: "1rem",
                                    }}
                                >
                                    0.03 ETH
                                    <span style={{color: "#c1c1c1", marginLeft: "1.2rem",}}>$160</span>
                                </ParaText>
                            </Grid>
                        </Grid>

                    </SmallRewardCard>

                    <SmallRewardCard>
                        <RewardCardSmallLayer></RewardCardSmallLayer>
                        <Grid
                            container
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <Grid
                                item
                                xs={6}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ParaText>
                                    02/27
                                    <LightChip
                                        avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                                        label="@leahx1621"
                                        style={{ marginLeft: "25px", }}
                                    />
                                </ParaText>
                            </Grid>
                            <Grid item xs={6} sx={{ textAlign: "end" }}>
                                <ParaText
                                    style={{
                                        fontSize: "1.4rem",
                                        marginRight: "1rem",
                                    }}
                                >
                                    0.03 ETH
                                    <span style={{color: "#c1c1c1", marginLeft: "1.2rem",}}>$160</span>
                                </ParaText>
                            </Grid>
                        </Grid>

                    </SmallRewardCard>

                </Box>
            </ThemeProvider>
        </React.Fragment>
    );
};

export default CreatorFundBody;
